import { useState, useEffect } from "react"
import { Box, Typography } from "@mui/material"
import { useSocketsContext } from '../../../contexts/sockets.context'
import { observer } from 'mobx-react'
import { useMeetingStore } from '../../../store/meeting.store'
import { useOnlineSessionsSocketStore } from '../../../store/onlinesessionsocket.store'


const MeetingReactions = observer( () => {
    const [reactions, setReactions] = useState( [] )

    // const {  onEvent } = useSocketsContext()
    const OnlineSessionSocketStore = useOnlineSessionsSocketStore()

    const MeetingStore = useMeetingStore()

    useEffect( () => {

        const handleShowReactions = ( { emoji, user } ) => {
            const id = Date.now() + Math.random()
            setReactions( ( prev ) => {
                const newReaction = { id, emoji, user, pos: Math.random() * 30 - 20 }
                const classes = ["animation-float-up"]

                if ( emoji === "👍" )
                    classes.push( "animation-shake" )

                newReaction.classes = classes.join( " " )
                return [...prev, newReaction]
            } )

            // auto-remove after animation ends (~2s)
            setTimeout( () => {
                setReactions( ( prev ) => prev.filter( ( r ) => r.id !== id ) )
            }, 2000 )
        }
        // listen for reactions from server
        const unsubShowNewReactionsEvent = OnlineSessionSocketStore.on( "reactions:show-reaction", handleShowReactions )

        return () => {
            unsubShowNewReactionsEvent()
        }
    }, [OnlineSessionSocketStore] )

    return (
        <Box position="fixed" top="0" zIndex={5000} sx={{ pointerEvents: "none" }} left="0" width="100%" height="100%">
            {reactions.map( ( r ) => (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    key={r.id}
                    className={r.classes}
                    sx={{
                        left: `${20 + ( r.pos )}%`, // small horizontal variation
                    }}
                >
                    {r.emoji}
                    <Typography textAlign="center" fontWeight="800">{r.user?.user_id === MeetingStore.getLocalUser?.user_id ? "You" : r.user?.name}</Typography>
                </Box>
            ) )}
        </Box>
    )
} )


export default MeetingReactions